import { type z } from 'zod';

import type { DashboardLogadoBaseParams } from '@/features/performance-dashboard/schemas/dashboard-logado-params';
import { performanceDashboardBaseParamsSchema } from '@/features/performance-dashboard/schemas/dashboard-resultado-params';
import {
  performanceByCompetenceResponseSchema,
  type PerformanceByCompetenceResponse,
} from '@/features/performance-dashboard/schemas/performanceByCompetence';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getPerformanceByCompetenceParamsSchema = performanceDashboardBaseParamsSchema;

export type GetPerformanceByCompetenceParams = z.infer<typeof getPerformanceByCompetenceParamsSchema>;

export const getPerformanceByCompetence = httpGetAdapter<
  PerformanceByCompetenceResponse,
  GetPerformanceByCompetenceParams
>({
  url: '/v3/dashboard/resultado/desempenho-por-competencia',
  schema: performanceByCompetenceResponseSchema,
  mapParams: (params) => params,
});

export type GetPerformanceByCompetenceByTaskParams = { idTask: number };

export const getPerformanceByCompetenceByTask = httpGetAdapter<
  PerformanceByCompetenceResponse,
  GetPerformanceByCompetenceByTaskParams
>({
  url: (params) => `/v3/dashboard/resultado/tarefa/${params.idTask}/desempenho-por-competencia`,
  schema: performanceByCompetenceResponseSchema,
});

export type GetPerformanceByCompetenceLogadoParams = DashboardLogadoBaseParams;

export const getPerformanceByCompetenceLogado = httpGetAdapter<
  PerformanceByCompetenceResponse,
  GetPerformanceByCompetenceLogadoParams
>({
  url: '/v3/dashboard/resultado/desempenho-por-competencia/logado',
  schema: performanceByCompetenceResponseSchema,
  mapParams: (params) => ({
    anoLetivo: params.anoLetivo,
    categoriaId: params.categoriaId,
    nomModelo: params.nomModelo,
  }),
});
